module.exports = "<main id=\"error\">\n  <section>\n    <article>\n      <h1 translate>notFound.title</h1>\n      <img src=\"/assets/img/404.svg\" alt=\"\">\n      <p><p translate>notFound.message<a [routerLink]=\"['/']\" translate>notFound.link</a></p>\n    </article>\n  </section>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/not-found/not-found.component.html
// module id = ../../../../../src/app/not-found/not-found.component.html
// module chunks = main